import * as Sentry from '@sentry/react'
import { Routes } from 'react-router-dom'

export const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes)
